import React from 'react';

interface NumberStepperProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  min?: number;
}

export const NumberStepper: React.FC<NumberStepperProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  min = 0,
}) => {
  const decrement = () => {
    if (disabled) return;
    onChange(Math.max(min, value - 1));
  };

  const increment = () => {
    if (disabled) return;
    onChange(value + 1);
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-xs font-medium text-gray-600 text-center leading-tight">{label}</span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={decrement}
          disabled={disabled || value <= min}
          aria-label={`Decrease ${label}`}
          className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-40 min-h-touch min-w-touch"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
          </svg>
        </button>
        <span className="w-10 text-center text-lg font-semibold text-gray-900 tabular-nums">{value}</span>
        <button
          type="button"
          onClick={increment}
          disabled={disabled}
          aria-label={`Increase ${label}`}
          className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-40 min-h-touch min-w-touch"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>
    </div>
  );
};
